<template>
  <VueTypeaheadBootstrap
    v-model="search"
    :data="paises"
    :serializer="(item) => item.nome"
    :placeholder="placeholder"
    @input="findPais"
    @hit="pais = $event"
    :class="[stateClass]"
    :size="size"
    showAllResults
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";
import { debounce } from "lodash";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {},
    placeholder: {
      type: String,
      default: "Buscar  ...",
    },
    return_object: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    pais: null,
    search: "",
    paises: [],
  }),
  computed: {},
  methods: {
    ...mapActions("municipios", ["ActionFindPais", "ActionFindPaisByIso"]),
    findPais: debounce(async function () {
      let payload = { q: this.search };
      this.paises = await this.ActionFindPais(payload);
      //this.paises = paises.data;
    }, 500),

    async setPaisByIso(iso) {
      if (iso) {
        let pais = await this.ActionFindPaisByIso(iso);
        if (pais.iso3) {
          this.pais = pais;
        }
      }
    },
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.pais = null;
      }
    },
    pais: function () {
      if (this.pais) {
        this.search = this.pais.nome;
        this.paises = [this.pais];
        this.$emit("input", this.pais.iso3);
      } else {
        this.$emit("input", null);
      }
    },
    value: function (value) {
      let ibge = this.return_object ? value.iso3 : value;
      this.setPaisByIso(value);
    },
  },
  async created() {
    if (this.value) {
      this.setPaisByIso(this.value);
    }
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-top: 0 !important;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}
</style>
